import React from 'react';
import { usePatientDiscountFormEffect } from './patient-discount-form.effect';
import { PromoCode } from '../../../data/pages/checkout/promo-code';
import { ToastMolecule } from '../../molecules';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../services';

export const PatientDiscountFormOrganism = () => {
  const { isValid, members, onSubmit, error, loading, success, errorMessage } =
    usePatientDiscountFormEffect();

  const [discount] = useSelector((state: StoreState) => {
    return [state.catalog.discount];
  });

  return (
    <div data-cy="checkout-discount-form-organism" className="w-full lg:ml-2">
      {error && (
        <div className="text-waldo-tangerine text-sm font-medium mb-5">
          <ToastMolecule
            toastList={[
              {
                id: 1,
                title: 'Discount Code',
                description: errorMessage,
                bgColor: 'bg-waldo-poppy',
                icon: 'warning',
              },
            ]}
            position="Top-Left"
            autoDelete={true}
            autoDeleteTime={1000}
          />
        </div>
      )}
      {success && (
        <div className="text-waldo-tangerine text-sm font-medium mb-5">
          <ToastMolecule
            toastList={[
              {
                id: 1,
                title: 'Discount Code',
                description: 'Discount Code Successfully Applied!',
                bgColor: 'bg-waldo-blue',
                icon: 'info',
              },
            ]}
            position="Top-Left"
            autoDelete={true}
            autoDeleteTime={1000}
          />
        </div>
      )}
      {discount.data === null ? (
        <>
          <p className="text-base font-semibold">
            {PromoCode.ENTER_PROMO_CODE_DESC}
          </p>

          <form onSubmit={onSubmit}>
            <div className="flex w-full justify-between flex-row mt-5">
              <div className="w-3/5">
                <label htmlFor="discount-code" className="hidden" />
                <input
                  className={`border-waldo-blue border py-5 input-discount-code {

              ${
                !members.code.isClean && !members.code.isValid
                  ? 'input-error-border'
                  : ''
              }`}
                  id="discount-code"
                  type="text"
                  placeholder="Add promo code"
                  onChange={(e) => members.code.onChange(e.target.value)}
                  onFocus={() => members.code.onFocus()}
                  onBlur={() => members.code.onBlur()}
                  value={members.code.value as string}
                />
              </div>
              <div className="lg:w-32">
                <button
                  className="button py-3 btn-third-cta w-full disabled:bg-waldo-blue bg-waldo-light-blue disabled:bg-opacity-20 hover:-translate-y-0"
                  disabled={!isValid || loading}
                >
                  {PromoCode.APPLY}
                </button>
              </div>
            </div>
          </form>
        </>
      ) : (
        <div>
          <img
            src="/images/checkout/check-green-icon.svg"
            className="inline-block"
          />
          <span
            className="mr-3 ml-0.5 text-base font-semibold inline-block"
            style={{ color: '#00a07b' }}
          >
            Code has been applied
          </span>
          <a className="underline_blue text-waldo-blue inline-block">
            Remove Code
          </a>
        </div>
      )}
    </div>
  );
};
